import Coin from "../Coin.js";
import CoinTextureManager from "../CoinTextureManager.js";

class Coins {
	coins = [];
	textureManager = null;

	async setup(scene, canvas, foregroundLayer, textureQuality = {}) {
		// Create texture manager instance (shared across all coins)
		this.textureManager = new CoinTextureManager(textureQuality);

		// Setup the coins
		const coinLabelsRaw = canvas.getAttribute("data-coin-labels");
		const coinLabels = JSON.parse(coinLabelsRaw);

		// Create all coins and collect their material promises
		const materialPromises = [];
		coinLabels.forEach((label, index) => {
			const coin = new Coin(scene, index, coinLabels.length, label, this.textureManager);
			// Set initial rotation
			coin.container.rotation.y = coin.orbitalRotation;
			// Set coins to foreground layer by default (normal rendering)
			coin.container.layers.set(foregroundLayer);
			this.coins.push(coin);
			// Collect promise for material loading
			if (coin.materialsPromise) {
				materialPromises.push(coin.materialsPromise);
			}
		});

		// Wait for all materials to be loaded before completing setup
		await Promise.all(materialPromises);
	}

	updateTextureQuality(textureQuality = {}) {
		if (!this.textureManager) {
			return Promise.resolve(false);
		}

		return this.textureManager.updateTextureQuality(textureQuality);
	}

	update({ wheelRotation, mousePos, timeDelta, state, revealAnimationManager = null, spinsPerSecond = 0, layoutScale = 1, prefersReducedMotion = false }) {
		this.coins.forEach((coin) => {
			// Skip orbital rotation update if this coin is being animated in reveal
			const isBeingAnimated =
				revealAnimationManager && revealAnimationManager.getAnimatedCoin() === coin;

			if (!isBeingAnimated) {
				const rotationPerCoin = (Math.PI * 2) / coin.totalCoins;
				coin.orbitalRotation = wheelRotation + coin.index * rotationPerCoin;
				coin.container.rotation.y = coin.orbitalRotation;
			}

			coin.update({
				spinsPerSecond: 0, // Don't let coin.update modify orbitalRotation
				timeDelta,
				mousePos,
				state,
				skipRotationUpdate: isBeingAnimated, // Skip rotation update for animated coin
				skipCoinSpinUpdate: isBeingAnimated, // Skip coin spin update for animated coin (let GSAP control it)
				layoutScale,
				prefersReducedMotion, // Pass reduced motion preference to disable hover effects
			});
		});
	}

	setOrbitRadius(radius, animatedCoin = null) {
		// Update all coins' orbit radius, but skip the coin being animated in reveal
		this.coins.forEach((coin) => {
			// Don't update orbit radius for the coin being animated (GSAP controls its position)
			if (coin !== animatedCoin) {
				coin.setOrbitRadius(radius);
			}
		});
	}
}

export default Coins;
